import styles from "./index.module.scss";
import classes from "classnames";

export interface ProgressProps {
  current: number;
  total: number;
  label?: string;
  className?: string;
}
const Progress = ({ current, total, className, label }: ProgressProps) => {
  return (
    <div className={classes(styles.progress, className)}>
      {label && <div style={{ marginRight: 6 }}>{label}</div>}

      <progress max={total} value={current} className={styles.bar} />
      <div className={styles.indicator}>
        {current}/{total}
      </div>
    </div>
  );
};

export default Progress;
